var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navTabs"},_vm._l((_vm.tabs),function(value,index){return _c('div',{key:value+index},[_vm._v(" "+_vm._s(value)+" "),(!_vm.$store.state.isPc)?_c('span',[_vm._v(_vm._s(index+1))]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }